import React, {CSSProperties, PropsWithChildren} from 'react';
import cx from 'classnames';
import styles from './Description.module.scss';

export default function Description({ children, className = '', maxWidth }: PropsWithChildren<{
  className?: string;
  maxWidth?: CSSProperties['maxWidth'];
}>) {
    return (
        <p className={cx({
            'neutral-700': true,
            [styles.Description]: true,
            [className]: true,
        })} style={{ maxWidth }}>
            {children}
        </p>
    );
}
